import { Alert } from 'antd'

import { HivAnamnesisFormSection } from 'src/api/requests'
import { useLocales } from 'src/locales'

const SECTION_TITLE_KEYS: Record<HivAnamnesisFormSection, string> = {
  [HivAnamnesisFormSection.HEADER]: 'hiv_anamnesis.header.title',
  [HivAnamnesisFormSection.INSTITUTIONS]: 'hiv_anamnesis.header.title',
  [HivAnamnesisFormSection.PATIENT]: 'hiv_anamnesis.patient.title',
  [HivAnamnesisFormSection.TESTING]: 'hiv_anamnesis.testing.title',
  [HivAnamnesisFormSection.TRANSMISSION_ADULT]:
    'hiv_anamnesis.transmission.title',
  [HivAnamnesisFormSection.TRANSMISSION_CHILD]:
    'hiv_anamnesis.transmission.title',
  [HivAnamnesisFormSection.TRANSMISSION_OTHER]:
    'hiv_anamnesis.transmission.title',
  [HivAnamnesisFormSection.FAMILY]: 'hiv_anamnesis.family.title',
  [HivAnamnesisFormSection.CLINICAL]: 'hiv_anamnesis.clinical.title'
}

/** The card titles of the given sections, once each, joined for a message. */
export const useSectionTitles = () => {
  const { t } = useLocales()

  return (sections: HivAnamnesisFormSection[]) =>
    [...new Set(sections.map((x) => t(SECTION_TITLE_KEYS[x])))].join(', ')
}

type Props = {
  isError: boolean
  failedSections?: HivAnamnesisFormSection[]
}

/**
 * Tells the doctor the system data could not be taken (all of it, or some sections), so the empty
 * fields are filled in by hand instead of being mistaken for "no data in the system".
 */
export const PrefillWarning = ({ isError, failedSections }: Props) => {
  const { t } = useLocales()
  const sectionTitles = useSectionTitles()

  if (isError) {
    return (
      <Alert
        type="warning"
        showIcon
        message={t('hiv_anamnesis.prefill_warning.failed_title')}
        description={t('hiv_anamnesis.prefill_warning.failed_description')}
      />
    )
  }

  if (!failedSections?.length) return null

  return (
    <Alert
      type="warning"
      showIcon
      message={t('hiv_anamnesis.prefill_warning.partial_title')}
      description={t('hiv_anamnesis.prefill_warning.partial_description', {
        sections: sectionTitles(failedSections)
      })}
    />
  )
}
